<template>
  <v-select
    outlined
    v-model="selected"
    :items="page.items"
    :menu-props="{ maxHeight: '400', zIndex: 13 }"
    label="Entité"
    item-text="name"
    item-value="id"
  ></v-select>
</template>

<script>
import {
  computed,
  onMounted,
  reactive,
  set,
  watch,
} from "@vue/composition-api";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";
import useQueryString from "@/hooks/useQueryString";

import { URL_PARAM_NAMES } from "@/utils/constants";

const COMPONENT_NAME = "FinanceMappingEntityFilter";

export default {
  name: COMPONENT_NAME,
  setup(props, { emit }) {
    const { store } = useProxy();
    const { axiosGet } = useAxios();

    const { addQueryStringParam, synchronizeFilterWithQueryString } =
      useQueryString();

    const page = reactive({
      isInitialized: false,
      initialUrlValue: [], // in case we need to load from url params
      items: [],
    });

    // =>  METHODS

    // =>  COMPUTED
    const selected = computed({
      get: () => store.getters["finance/getMappingEntity"],
      set(e) {
        store.dispatch("finance/updateMappingEntity", e);
      },
    });

    // =>  WATCH
    watch(selected, (newValue) => {
      if (page.isInitialized) {
        // Only update user changes, not initialization
        addQueryStringParam({
          param: URL_PARAM_NAMES[COMPONENT_NAME],
          value: newValue,
          // is_multiple: false,
          // is_integer: false,
          // is_boolean: false,
        });
      }
    });

    // =>  HOOKS
    onMounted(async () => {
      const { data } = await axiosGet("/finance/mapping/entities");
      set(
        page,
        "items",
        Object.entries(data).map(([key, value]) => ({ id: key, name: value }))
      );

      set(
        page,
        "initialUrlValue",
        await synchronizeFilterWithQueryString({
          dispatcher: "finance/updateMappingEntity",
          param: URL_PARAM_NAMES[COMPONENT_NAME],
          value: selected.value,
          // is_multiple: false,
          // is_integer: false,
          // is_boolean: false,
          // dependsOn: undefined,
        })
      );

      page.isInitialized = true;
    });

    // =>  DATA
    return {
      page,
      selected,
    };
  },
};
</script>

<style></style>
